import * as React from 'react';
import './Banner.scss';

interface Props {
  children: React.ReactNode;
  classes?: string;
  rounded?: boolean;
  type: string;
}

export const Banner = ({
  children,
  classes,
  rounded,
  type
}: Props) => {
  const allClasses = [
    rounded ? 'u-borderRadiusMd' : '',
    `${type}-class`,
    classes ? classes : '',
  ]
    .join(' ')
    .replace(/\s+/g, ' ');

  return (
    <div data-testid="banner-area">
      <div
        className={allClasses}
        data-testid="banner-area-body"
      >
        {children}
      </div>
    </div>
  )
}
